import { useCallback, useState } from 'react'

import {
  POST_COMPENSATION_WITHDRAW_ORDERS_DELETE,
  convertParams,
  convertResult,
} from 'app/common/api/requests/cabinet/compensation/withdraw_orders/delete/post'

import { api } from 'app/api'
import useCallbackRef from 'app/common/hooks/useCallbackRef'


type Options = {
  onRemoveSuccess?: (ID: string) => void
}

export function useCompensationStatementsActions({ onRemoveSuccess }: Options = {}) {
  const [pendingIDs, setPendingIDs] = useState(new Set())

  const onRemoveSuccessRef = useCallbackRef(onRemoveSuccess)

  const modifyPendingIDs = useCallback((action: 'add' | 'remove', ID: string) => {
    setPendingIDs((prev) => {
      const next = new Set(prev)
      if (action === 'add') next.add(ID)
      if (action === 'remove') next.delete(ID)
      return next
    })
  }, [])

  const remove = useCallback(async (statementID: string) => {
    modifyPendingIDs('add', statementID)
    const res = await api.request(POST_COMPENSATION_WITHDRAW_ORDERS_DELETE, {
      error: 'Не удалось удалить заявку',
      params: { statementID },
      convertions: {
        convertParams,
        convertResult,
      },
    })
    modifyPendingIDs('remove', statementID)
    if (res) {
      onRemoveSuccessRef.current?.(statementID)
    }

    return !!res
  }, [modifyPendingIDs, onRemoveSuccessRef])

  return {
    pendingIDs,
    remove,
  }
}
